module.exports = __webpack_public_path__ + "img/furgone.23eb0e96.svg";